module.exports = __webpack_public_path__ + "cdc25f2a29280c615a9f9a409c4f688d.jpg";